import { Box, Icon, Image } from '@podiumhq/design-system';

import visaIcon from './assets/visa.svg';
import amexIcon from './assets/amex.svg';
import mastercardIcon from './assets/mastercard.svg';
import discoverIcon from './assets/discover.svg';

const CreditCardIconsRow = (props) => (
  <Box {...props}>
    <CreditCardIcon src={visaIcon} alt="visa icon" />
    <CreditCardIcon src={amexIcon} alt="amex icon" />
    <CreditCardIcon src={mastercardIcon} alt="mastercard icon" />
    <CreditCardIcon src={discoverIcon} alt="discover icon" />

    <Icon boxSize={6} color="grey.light" fill="grey.light" type="Lock" />
  </Box>
);

const CreditCardIcon = ({ src, ...props }) => (
  <Image paddingRight="8px" width="32px" src={src} {...props} />
);

export default CreditCardIconsRow;
